import {Injectable} from '@angular/core';

import {AlertsConfig} from '../_models/index';

import {AuthenticationService} from './index';
import {LoginHelper} from '../helpers';
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class NotificationService {
    constructor(public http: HttpClient,
                public authenticationService: AuthenticationService,
                public config: IndexConfigService) { }

  sendNotification() {

    if (LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(
      this.config.api + '/api/notifications/send');
  }

  unsubscribeNotification(type, key, tenantName) {
    return this.http.get<any>(
      this.config.api + `/api/notifications/unsubscribe?type=${type}&key=${encodeURIComponent(key)}&tenantName=${tenantName}`);
  }

  getAlertsConfiguration() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
            this.authenticationService.logout();

            return null;
        }

        return this.http.get<any>(
            this.config.api + '/api/notifications/all');
    }

  @Load()
    saveAlertsConfiguration(alertsConfig: AlertsConfig) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
            this.authenticationService.logout();

            return null;
        }

        return this.http.post<any>(
            this.config.api + '/api/notifications/save',
            alertsConfig);
    }
}
